<template>
  <div class="popUpWrap" :class="{ black: dialogProps.popupClass === 'dark' }">
    <section class="popup" :class="popupClass" :style="dialogProps.popupStyle">
      <div class="topArea">
        <div class="exit" @click.stop="onClickExit"></div>
      </div>
      <div class="scrollY">
        <div v-if="dialogProps.icon" :class="['icon', dialogProps.icon]"></div>
        <div class="textArea flex">
          <h5 style="white-space: pre-line">{{ dialogProps.title }}</h5>
          <p v-if="dialogProps.contents" v-html="contentsHtml" />
        </div>
        <div class="btnArea">
          <button class="cancel" :style="cancelStyle" @click.stop="onClickClose">{{ closeTitle }}</button>
          <button @click.stop="onClickConfirm">{{ confirmTitle }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from '#imports';
import { convertToNextLine } from '~~/application/utils/StringUtil';
import { useDialogStore } from '~/store/dialog/dialogStore';
import { useI18n } from 'vue-i18n';
import type { GenericDialogProps } from '~/components/Common/Dialog/model/GenericDialogProps';

const { t } = useI18n();
const dialogStore = useDialogStore();

const dialogProps = computed(() => dialogStore.options.props as GenericDialogProps);

// GenericAlertPopup 과 같은 이유로 `\n` 을 줄바꿈으로 그린다 — 같은 로케일 문구가 알림/확인
// 팝업에서 서로 다르게 보이지 않게 한다.
const contentsHtml = computed(() => convertToNextLine(dialogProps.value.contents ?? ''));

const popupClass = computed(() => {
    const cls = dialogProps.value.popupClass ?? 'dark basic';
    return cls === 'dark' ? 'dark basic' : cls;
});
const confirmTitle = computed(() => dialogStore.options.confirm?.title ?? t('common-ok'));
const closeTitle = computed(() => dialogStore.options.close?.title ?? t('common-cancel'));
const cancelStyle = computed(() => {
    if (dialogProps.value.isWide) {
        return { 'min-width': 'fit-content', width: '250%', 'max-width': '223px' };
    }
    return {};
});

const onClickExit = () => {
    dialogStore.close();
    (dialogStore.options.exit ?? dialogStore.options.close)?.event();
};

const onClickClose = () => {
    dialogStore.close();
    dialogStore.options.close?.event();
};

const onClickConfirm = () => {
    dialogStore.close();
    dialogStore.options.confirm?.event();
};
</script>

